import React from 'react';
import ReactDOM from 'react-dom/client';
//import './index.css';
import App from './App';
//Import the Bootsrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
//import AppNavbar from './components/AppNavbar';
//import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

